// ============================================================
// Real-life team rosters for FIFA Club World Cup & Asian Cup
// Ratings: CWC 86-99, Asian Cup 76-87 (realistic tiers)
// ============================================================
import { EMPTY_STATS, ROSTER_SIZE, LINEUP_SIZE, BENCH_SIZE, FORMATIONS, buildLineupForFormation } from './gameData';

// ============================================================
// 32 CWC TEAMS - mostly European + top clubs from other confederations
// `teamOvr` drives filler player rating band
// `stars` = real-life star players (verbatim names). Remainder filled with realistic squad players.
// ============================================================
export const CWC_TEAMS_DATA = [
  // TIER 1 - 94-99 ovr
  { name: 'Madrid Royal', country: 'Spain', flag: '🇪🇸', teamOvr: 97, formation: '4-3-3', stars: [
    { name: 'Thibaut Courtois', position: 'GK', overall: 90, age: 33 },
    { name: 'Antonio Rüdiger', position: 'CB', overall: 87, age: 32 },
    { name: 'Éder Militão', position: 'CB', overall: 86, age: 27 },
    { name: 'Dani Carvajal', position: 'RB', overall: 86, age: 33 },
    { name: 'Ferland Mendy', position: 'LB', overall: 83, age: 30 },
    { name: 'Aurélien Tchouaméni', position: 'CDM', overall: 87, age: 25 },
    { name: 'Federico Valverde', position: 'CM', overall: 89, age: 27 },
    { name: 'Jude Bellingham', position: 'CAM', overall: 92, age: 22 },
    { name: 'Vinícius Júnior', position: 'LW', overall: 93, age: 25 },
    { name: 'Kylian Mbappé', position: 'ST', overall: 97, age: 27 },
    { name: 'Rodrygo', position: 'RW', overall: 88, age: 25 }
  ]},
  { name: 'Manchester Citizens', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 96, formation: '4-2-3-1', stars: [
    { name: 'Ederson', position: 'GK', overall: 88, age: 32 },
    { name: 'Kyle Walker', position: 'RB', overall: 84, age: 35 },
    { name: 'Rúben Dias', position: 'CB', overall: 89, age: 28 },
    { name: 'Manuel Akanji', position: 'CB', overall: 85, age: 30 },
    { name: 'Joško Gvardiol', position: 'LB', overall: 86, age: 24 },
    { name: 'Rodri', position: 'CDM', overall: 92, age: 29 },
    { name: 'Bernardo Silva', position: 'CM', overall: 88, age: 31 },
    { name: 'Phil Foden', position: 'CAM', overall: 89, age: 25 },
    { name: 'Jack Grealish', position: 'LW', overall: 85, age: 30 },
    { name: 'Erling Haaland', position: 'ST', overall: 94, age: 25 },
    { name: 'Savinho', position: 'RW', overall: 82, age: 21 }
  ]},
  { name: 'Munich FC', country: 'Germany', flag: '🇩🇪', teamOvr: 95, formation: '4-2-3-1', stars: [
    { name: 'Manuel Neuer', position: 'GK', overall: 86, age: 39 },
    { name: 'Konrad Laimer', position: 'RB', overall: 82, age: 28 },
    { name: 'Dayot Upamecano', position: 'CB', overall: 85, age: 27 },
    { name: 'Min-Jae Kim', position: 'CB', overall: 84, age: 29 },
    { name: 'Alphonso Davies', position: 'LB', overall: 84, age: 25 },
    { name: 'Joshua Kimmich', position: 'CM', overall: 89, age: 30 },
    { name: 'Aleksandar Pavlović', position: 'CDM', overall: 79, age: 21 },
    { name: 'Jamal Musiala', position: 'CAM', overall: 89, age: 22 },
    { name: 'Michael Olise', position: 'RW', overall: 85, age: 23 },
    { name: 'Harry Kane', position: 'ST', overall: 90, age: 32 },
    { name: 'Leroy Sané', position: 'LW', overall: 86, age: 29 }
  ]},
  { name: 'Catalonia FC', country: 'Spain', flag: '🇪🇸', teamOvr: 95, formation: '4-3-3', stars: [
    { name: 'Marc-André ter Stegen', position: 'GK', overall: 87, age: 33 },
    { name: 'Pau Cubarsí', position: 'CB', overall: 80, age: 18 },
    { name: 'Ronald Araújo', position: 'CB', overall: 86, age: 26 },
    { name: 'Jules Koundé', position: 'RB', overall: 86, age: 27 },
    { name: 'Alejandro Baldé', position: 'LB', overall: 82, age: 22 },
    { name: 'Frenkie de Jong', position: 'CM', overall: 85, age: 28 },
    { name: 'Pedri', position: 'CM', overall: 87, age: 23 },
    { name: 'Gavi', position: 'CM', overall: 83, age: 21 },
    { name: 'Lamine Yamal', position: 'RW', overall: 88, age: 18 },
    { name: 'Robert Lewandowski', position: 'ST', overall: 88, age: 37 },
    { name: 'Raphinha', position: 'LW', overall: 86, age: 28 }
  ]},
  { name: 'Paris Saints', country: 'France', flag: '🇫🇷', teamOvr: 94, formation: '4-3-3', stars: [
    { name: 'Gianluigi Donnarumma', position: 'GK', overall: 89, age: 26 },
    { name: 'Achraf Hakimi', position: 'RB', overall: 86, age: 27 },
    { name: 'Marquinhos', position: 'CB', overall: 87, age: 31 },
    { name: 'Willian Pacho', position: 'CB', overall: 82, age: 24 },
    { name: 'Nuno Mendes', position: 'LB', overall: 84, age: 23 },
    { name: 'Vitinha', position: 'CM', overall: 86, age: 25 },
    { name: 'João Neves', position: 'CM', overall: 83, age: 21 },
    { name: 'Fabián Ruiz', position: 'CM', overall: 84, age: 29 },
    { name: 'Ousmane Dembélé', position: 'LW', overall: 86, age: 28 },
    { name: 'Bradley Barcola', position: 'RW', overall: 82, age: 23 },
    { name: 'Désiré Doué', position: 'CAM', overall: 80, age: 20 }
  ]},
  { name: 'Merseyside Reds', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 94, formation: '4-3-3', stars: [
    { name: 'Alisson Becker', position: 'GK', overall: 89, age: 33 },
    { name: 'Trent Alexander-Arnold', position: 'RB', overall: 87, age: 27 },
    { name: 'Virgil van Dijk', position: 'CB', overall: 89, age: 34 },
    { name: 'Ibrahima Konaté', position: 'CB', overall: 84, age: 26 },
    { name: 'Andy Robertson', position: 'LB', overall: 85, age: 31 },
    { name: 'Alexis Mac Allister', position: 'CM', overall: 85, age: 27 },
    { name: 'Ryan Gravenberch', position: 'CDM', overall: 82, age: 23 },
    { name: 'Dominik Szoboszlai', position: 'CM', overall: 84, age: 25 },
    { name: 'Mohamed Salah', position: 'RW', overall: 90, age: 33 },
    { name: 'Luis Díaz', position: 'LW', overall: 85, age: 28 },
    { name: 'Darwin Núñez', position: 'ST', overall: 83, age: 26 }
  ]},
  { name: 'North London Gunners', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 93, formation: '4-3-3', stars: [
    { name: 'David Raya', position: 'GK', overall: 85, age: 30 },
    { name: 'Ben White', position: 'RB', overall: 84, age: 28 },
    { name: 'William Saliba', position: 'CB', overall: 87, age: 24 },
    { name: 'Gabriel Magalhães', position: 'CB', overall: 86, age: 28 },
    { name: 'Riccardo Calafiori', position: 'LB', overall: 80, age: 23 },
    { name: 'Declan Rice', position: 'CDM', overall: 87, age: 26 },
    { name: 'Martin Ødegaard', position: 'CAM', overall: 87, age: 26 },
    { name: 'Mikel Merino', position: 'CM', overall: 83, age: 29 },
    { name: 'Bukayo Saka', position: 'RW', overall: 88, age: 24 },
    { name: 'Gabriel Martinelli', position: 'LW', overall: 84, age: 24 },
    { name: 'Kai Havertz', position: 'ST', overall: 83, age: 26 }
  ]},
  { name: 'Milano Inter', country: 'Italy', flag: '🇮🇹', teamOvr: 92, formation: '3-5-2', stars: [
    { name: 'Yann Sommer', position: 'GK', overall: 83, age: 37 },
    { name: 'Benjamin Pavard', position: 'CB', overall: 83, age: 29 },
    { name: 'Alessandro Bastoni', position: 'CB', overall: 86, age: 26 },
    { name: 'Francesco Acerbi', position: 'CB', overall: 81, age: 38 },
    { name: 'Denzel Dumfries', position: 'RWB', overall: 82, age: 29 },
    { name: 'Federico Dimarco', position: 'LWB', overall: 84, age: 28 },
    { name: 'Nicolò Barella', position: 'CM', overall: 87, age: 28 },
    { name: 'Hakan Çalhanoğlu', position: 'CDM', overall: 86, age: 31 },
    { name: 'Henrikh Mkhitaryan', position: 'CM', overall: 82, age: 36 },
    { name: 'Lautaro Martínez', position: 'ST', overall: 89, age: 28 },
    { name: 'Marcus Thuram', position: 'ST', overall: 85, age: 28 }
  ]},
  // TIER 2 - 88-92
  { name: 'Madrid Atleti', country: 'Spain', flag: '🇪🇸', teamOvr: 91, formation: '4-4-2', stars: [
    { name: 'Jan Oblak', position: 'GK', overall: 88, age: 32 },
    { name: 'José María Giménez', position: 'CB', overall: 83, age: 30 },
    { name: 'Antoine Griezmann', position: 'SS', overall: 85, age: 34 },
    { name: 'Julián Álvarez', position: 'ST', overall: 87, age: 25 },
    { name: 'Koke', position: 'CM', overall: 81, age: 33 },
    { name: 'Pablo Barrios', position: 'CM', overall: 79, age: 22 }
  ]},
  { name: 'Dortmund BVB', country: 'Germany', flag: '🇩🇪', teamOvr: 88, formation: '4-2-3-1', stars: [
    { name: 'Gregor Kobel', position: 'GK', overall: 84, age: 27 },
    { name: 'Nico Schlotterbeck', position: 'CB', overall: 82, age: 26 },
    { name: 'Serhou Guirassy', position: 'ST', overall: 84, age: 29 },
    { name: 'Julian Brandt', position: 'CAM', overall: 82, age: 29 },
    { name: 'Karim Adeyemi', position: 'LW', overall: 81, age: 23 }
  ]},
  { name: 'Piemonte Calcio', country: 'Italy', flag: '🇮🇹', teamOvr: 88, formation: '4-3-3', stars: [
    { name: 'Michele Di Gregorio', position: 'GK', overall: 82, age: 28 },
    { name: 'Gleison Bremer', position: 'CB', overall: 85, age: 28 },
    { name: 'Teun Koopmeiners', position: 'CM', overall: 84, age: 28 },
    { name: 'Dušan Vlahović', position: 'ST', overall: 84, age: 25 },
    { name: 'Kenan Yıldız', position: 'LW', overall: 80, age: 20 }
  ]},
  { name: 'Milano AC', country: 'Italy', flag: '🇮🇹', teamOvr: 88, formation: '4-2-3-1', stars: [
    { name: 'Mike Maignan', position: 'GK', overall: 87, age: 30 },
    { name: 'Theo Hernández', position: 'LB', overall: 85, age: 28 },
    { name: 'Rafael Leão', position: 'LW', overall: 86, age: 26 },
    { name: 'Christian Pulisic', position: 'RW', overall: 83, age: 27 },
    { name: 'Tijjani Reijnders', position: 'CM', overall: 83, age: 27 }
  ]},
  { name: 'London Blues', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 88, formation: '4-2-3-1', stars: [
    { name: 'Robert Sánchez', position: 'GK', overall: 80, age: 28 },
    { name: 'Moisés Caicedo', position: 'CDM', overall: 84, age: 24 },
    { name: 'Enzo Fernández', position: 'CM', overall: 84, age: 24 },
    { name: 'Cole Palmer', position: 'CAM', overall: 86, age: 23 },
    { name: 'Nicolas Jackson', position: 'ST', overall: 80, age: 24 }
  ]},
  { name: 'Napoli SSC', country: 'Italy', flag: '🇮🇹', teamOvr: 87, formation: '4-3-3', stars: [
    { name: 'Alex Meret', position: 'GK', overall: 82, age: 28 },
    { name: 'Amir Rrahmani', position: 'CB', overall: 82, age: 31 },
    { name: 'Scott McTominay', position: 'CM', overall: 82, age: 28 },
    { name: 'Khvicha Kvaratskhelia', position: 'LW', overall: 86, age: 24 },
    { name: 'Romelu Lukaku', position: 'ST', overall: 83, age: 32 }
  ]},
  { name: 'Manchester Reds', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 87, formation: '4-2-3-1', stars: [
    { name: 'André Onana', position: 'GK', overall: 83, age: 29 },
    { name: 'Lisandro Martínez', position: 'CB', overall: 83, age: 27 },
    { name: 'Bruno Fernandes', position: 'CAM', overall: 87, age: 31 },
    { name: 'Marcus Rashford', position: 'LW', overall: 83, age: 28 },
    { name: 'Alejandro Garnacho', position: 'RW', overall: 80, age: 21 }
  ]},
  { name: 'North London Spurs', country: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Guglielmo Vicario', position: 'GK', overall: 83, age: 28 },
    { name: 'Cristian Romero', position: 'CB', overall: 85, age: 27 },
    { name: 'James Maddison', position: 'CAM', overall: 83, age: 28 },
    { name: 'Son Heung-min', position: 'LW', overall: 86, age: 33 },
    { name: 'Dominic Solanke', position: 'ST', overall: 81, age: 28 }
  ]},
  { name: 'Leverkusen FC', country: 'Germany', flag: '🇩🇪', teamOvr: 88, formation: '3-4-3', stars: [
    { name: 'Lukáš Hrádecký', position: 'GK', overall: 82, age: 35 },
    { name: 'Jonathan Tah', position: 'CB', overall: 84, age: 29 },
    { name: 'Granit Xhaka', position: 'CM', overall: 84, age: 33 },
    { name: 'Florian Wirtz', position: 'CAM', overall: 89, age: 22 },
    { name: 'Victor Boniface', position: 'ST', overall: 82, age: 24 }
  ]},
  { name: 'Leipzig RB', country: 'Germany', flag: '🇩🇪', teamOvr: 86, formation: '4-2-3-1', stars: [
    { name: 'Péter Gulácsi', position: 'GK', overall: 81, age: 35 },
    { name: 'Willi Orbán', position: 'CB', overall: 81, age: 33 },
    { name: 'Xavi Simons', position: 'CAM', overall: 83, age: 22 },
    { name: 'Loïs Openda', position: 'ST', overall: 82, age: 25 }
  ]},
  { name: 'Atalanta BC', country: 'Italy', flag: '🇮🇹', teamOvr: 86, formation: '3-4-2-1', stars: [
    { name: 'Marco Carnesecchi', position: 'GK', overall: 80, age: 25 },
    { name: 'Ademola Lookman', position: 'ST', overall: 84, age: 28 },
    { name: 'Charles De Ketelaere', position: 'CAM', overall: 81, age: 24 }
  ]},
  { name: 'SL Benfica', country: 'Portugal', flag: '🇵🇹', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Anatoliy Trubin', position: 'GK', overall: 82, age: 24 },
    { name: 'Nicolás Otamendi', position: 'CB', overall: 81, age: 37 },
    { name: 'Ángel Di María', position: 'RW', overall: 82, age: 37 },
    { name: 'Vangelis Pavlidis', position: 'ST', overall: 80, age: 27 }
  ]},
  { name: 'FC Porto', country: 'Portugal', flag: '🇵🇹', teamOvr: 86, formation: '4-4-2', stars: [
    { name: 'Diogo Costa', position: 'GK', overall: 83, age: 26 },
    { name: 'Pepê', position: 'RW', overall: 81, age: 28 },
    { name: 'Samu Aghehowa', position: 'ST', overall: 79, age: 21 }
  ]},
  { name: 'Sporting Lisbon', country: 'Portugal', flag: '🇵🇹', teamOvr: 86, formation: '3-4-3', stars: [
    { name: 'Franco Israel', position: 'GK', overall: 78, age: 25 },
    { name: 'Morten Hjulmand', position: 'CDM', overall: 82, age: 26 },
    { name: 'Viktor Gyökeres', position: 'ST', overall: 87, age: 27 }
  ]},
  { name: 'Amsterdam AFC', country: 'Netherlands', flag: '🇳🇱', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Remko Pasveer', position: 'GK', overall: 78, age: 42 },
    { name: 'Kenneth Taylor', position: 'CM', overall: 78, age: 23 },
    { name: 'Brian Brobbey', position: 'ST', overall: 78, age: 23 }
  ]},
  { name: 'Eindhoven PSV', country: 'Netherlands', flag: '🇳🇱', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Walter Benítez', position: 'GK', overall: 80, age: 32 },
    { name: 'Luuk de Jong', position: 'ST', overall: 80, age: 35 },
    { name: 'Johan Bakayoko', position: 'RW', overall: 78, age: 22 }
  ]},
  { name: 'Andalucia Verdiblancos', country: 'Spain', flag: '🇪🇸', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Isco', position: 'CAM', overall: 82, age: 33 }
  ]},
  { name: 'Marseille OM', country: 'France', flag: '🇫🇷', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Pierre-Emerick Aubameyang', position: 'ST', overall: 81, age: 36 },
    { name: 'Adrien Rabiot', position: 'CM', overall: 82, age: 30 }
  ]},
  { name: 'Lyon OL', country: 'France', flag: '🇫🇷', teamOvr: 86, formation: '4-3-3', stars: [
    { name: 'Alexandre Lacazette', position: 'ST', overall: 79, age: 34 },
    { name: 'Rayan Cherki', position: 'CAM', overall: 80, age: 22 }
  ]},
  // NON-EUROPEAN TOP
  { name: 'Riyadh Hilal', country: 'Saudi Arabia', flag: '🇸🇦', teamOvr: 89, formation: '4-2-3-1', stars: [
    { name: 'Yassine Bounou', position: 'GK', overall: 84, age: 34 },
    { name: 'Kalidou Koulibaly', position: 'CB', overall: 82, age: 34 },
    { name: 'Rúben Neves', position: 'CDM', overall: 84, age: 28 },
    { name: 'Malcom', position: 'RW', overall: 83, age: 28 },
    { name: 'Aleksandar Mitrović', position: 'ST', overall: 85, age: 31 },
    { name: 'Neymar Jr', position: 'LW', overall: 87, age: 33 }
  ]},
  { name: 'Riyadh Nassr', country: 'Saudi Arabia', flag: '🇸🇦', teamOvr: 88, formation: '4-3-3', stars: [
    { name: 'Aymeric Laporte', position: 'CB', overall: 84, age: 31 },
    { name: 'Sadio Mané', position: 'LW', overall: 84, age: 33 },
    { name: 'Cristiano Ronaldo', position: 'ST', overall: 88, age: 40 }
  ]},
  { name: 'Rio Flamengo', country: 'Brazil', flag: '🇧🇷', teamOvr: 87, formation: '4-3-3', stars: [
    { name: 'Gabigol', position: 'ST', overall: 82, age: 29 },
    { name: 'Giorgian de Arrascaeta', position: 'CAM', overall: 82, age: 31 }
  ]},
  { name: 'São Paulo Palmeiras', country: 'Brazil', flag: '🇧🇷', teamOvr: 86, formation: '4-2-3-1', stars: [
    { name: 'Weverton', position: 'GK', overall: 82, age: 37 },
    { name: 'Gustavo Gómez', position: 'CB', overall: 81, age: 32 }
  ]},
  { name: 'Buenos Aires Juniors', country: 'Argentina', flag: '🇦🇷', teamOvr: 86, formation: '4-4-2', stars: [
    { name: 'Edinson Cavani', position: 'ST', overall: 79, age: 38 }
  ]}
];

// ============================================================
// 28 CHAMPIONS LEAGUE TEAMS - top European clubs (Top 4 EWFL teams join to make 32)
// ============================================================
// ============================================================
// ASIAN CUP — 28 elite Asian clubs (top 4 JWFL + these 28 = 32-team bracket)
// Ratings: 76-87 OVR (realistic tiers for J1, K-League, CSL, etc.)
// ============================================================
export const CHAMPIONS_LEAGUE_TEAMS_DATA = [
  // J2 / second-tier Japanese (not in JWFL top 4 already)
  { name: 'Tokyo Verdy', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 78 },
  { name: 'Avispa Fukuoka', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 76 },
  // South Korea — K League 1
  { name: 'Ulsan HD', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 84 },
  { name: 'Jeonbuk Motors', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 83 },
  { name: 'FC Seoul', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 82 },
  { name: 'Pohang Steelers', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 81 },
  // China — Super League
  { name: 'Shanghai Port', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 82 },
  { name: 'Shandong Taishan', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 80 },
  { name: 'Beijing Guoan', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 79 },
  // Saudi — SPL
  { name: 'Al Hilal SFC', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 87 },
  { name: 'Al Nassr FC', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 86 },
  { name: 'Al Ittihad', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 85 },
  { name: 'Al Ahli SC', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 83 },
  // UAE / Qatar
  { name: 'Al Ain FC', country: 'UAE', flag: '🇦🇪', league: 'ADNOC PL', teamOvr: 82 },
  { name: 'Shabab Al Ahli', country: 'UAE', flag: '🇦🇪', league: 'ADNOC PL', teamOvr: 80 },
  { name: 'Al Sadd SC', country: 'Qatar', flag: '🇶🇦', league: 'QSL', teamOvr: 82 },
  { name: 'Al Duhail', country: 'Qatar', flag: '🇶🇦', league: 'QSL', teamOvr: 80 },
  // Iran / Iraq
  { name: 'Persepolis FC', country: 'Iran', flag: '🇮🇷', league: 'PGL', teamOvr: 81 },
  { name: 'Esteghlal FC', country: 'Iran', flag: '🇮🇷', league: 'PGL', teamOvr: 80 },
  // Australia — A-League
  { name: 'Melbourne City', country: 'Australia', flag: '🇦🇺', league: 'A-League', teamOvr: 79 },
  { name: 'Western Sydney', country: 'Australia', flag: '🇦🇺', league: 'A-League', teamOvr: 78 },
  // Thailand / Uzbekistan / Vietnam
  { name: 'Buriram United', country: 'Thailand', flag: '🇹🇭', league: 'Thai L1', teamOvr: 78 },
  { name: 'Bangkok United', country: 'Thailand', flag: '🇹🇭', league: 'Thai L1', teamOvr: 77 },
  { name: 'Pakhtakor', country: 'Uzbekistan', flag: '🇺🇿', league: 'UPL', teamOvr: 78 },
  { name: 'Nasaf Qarshi', country: 'Uzbekistan', flag: '🇺🇿', league: 'UPL', teamOvr: 76 },
  // India / Indonesia / Malaysia
  { name: 'Mumbai City', country: 'India', flag: '🇮🇳', league: 'ISL', teamOvr: 76 },
  { name: 'Persija Jakarta', country: 'Indonesia', flag: '🇮🇩', league: 'Liga 1', teamOvr: 76 },
  { name: 'Johor Darul Tazim', country: 'Malaysia', flag: '🇲🇾', league: 'Super League', teamOvr: 77 }
];

// ============================================================
// Name pools for generated filler players
// ============================================================
const NAME_POOLS = {
  Spain: { first: ['Sergio','Carlos','Javier','Pablo','Diego','Álvaro','Hugo','Marcos','Adrián','Rodrigo','Iván','Daniel','Raúl','Jorge','Nacho'], last: ['García','Martínez','López','Sánchez','Pérez','Gómez','Fernández','Rodríguez','Hernández','Morales','Ruiz','Castro','Navarro','Torres','Romero'] },
  Italy: { first: ['Marco','Luca','Alessandro','Matteo','Giovanni','Andrea','Francesco','Gabriele','Antonio','Federico','Nicolò','Lorenzo','Davide','Simone','Pietro'], last: ['Rossi','Russo','Ferrari','Esposito','Bianchi','Romano','Colombo','Ricci','Marino','Greco','Bruno','Gallo','Conti','De Luca','Mancini'] },
  Germany: { first: ['Leon','Paul','Felix','Lukas','Max','Jonas','Tim','Luka','Noah','Moritz','Florian','Tobias','Julian','Sebastian','Niklas'], last: ['Müller','Schmidt','Schneider','Fischer','Weber','Meyer','Wagner','Becker','Schulz','Hoffmann','Koch','Richter','Klein','Wolf','Schröder'] },
  England: { first: ['Jack','Harry','Oliver','George','James','William','Thomas','Daniel','Joseph','Samuel','Luke','Alex','Ethan','Callum','Archie'], last: ['Smith','Brown','Taylor','Wilson','Davies','Evans','Thomas','Roberts','Johnson','Walker','Wright','Robinson','Thompson','Wood','Harris'] },
  France: { first: ['Lucas','Hugo','Louis','Raphaël','Arthur','Jules','Nathan','Léo','Adam','Ethan','Tom','Mathis','Mael','Théo','Enzo'], last: ['Martin','Bernard','Dubois','Thomas','Robert','Richard','Petit','Durand','Leroy','Moreau','Simon','Laurent','Lefebvre','Michel','Garnier'] },
  Portugal: { first: ['João','Miguel','Diogo','André','Tiago','Rafael','Rui','Pedro','Bruno','Gonçalo','Tomás','Francisco','Duarte','Vasco','Martim'], last: ['Silva','Santos','Ferreira','Pereira','Oliveira','Costa','Rodrigues','Martins','Jesus','Sousa','Fernandes','Gonçalves','Gomes','Lopes','Marques'] },
  Netherlands: { first: ['Daan','Sem','Lucas','Milan','Levi','Liam','Luuk','Noah','Finn','Jesse','Tijn','Bram','Thijs','Sven','Ruben'], last: ['de Jong','Jansen','de Vries','van den Berg','van Dijk','Bakker','Janssen','Visser','Smit','Meijer','de Boer','Mulder','de Groot','Bos','Vos'] },
  Brazil: { first: ['Gabriel','Lucas','Matheus','Pedro','João','Rafael','Bruno','Felipe','Thiago','Carlos','Ricardo','Leonardo','Daniel','Eduardo','Fernando'], last: ['Silva','Santos','Oliveira','Souza','Pereira','Rodrigues','Costa','Ferreira','Almeida','Ribeiro','Carvalho','Lima','Gomes','Martins','Araújo'] },
  Argentina: { first: ['Santiago','Matías','Lucas','Joaquín','Nicolás','Tomás','Juan','Agustín','Gonzalo','Emiliano','Franco','Diego','Martín','Sebastián','Ignacio'], last: ['González','Rodríguez','Fernández','López','Martínez','Pérez','Gómez','Sánchez','Díaz','Romero','Álvarez','Torres','Ruiz','Ramírez','Flores'] },
  'Saudi Arabia': { first: ['Mohammed','Abdullah','Ahmed','Ali','Omar','Salman','Khalid','Yousef','Fahad','Saleh','Sultan','Bandar','Majed','Rayan','Faris'], last: ['Al-Saud','Al-Ghamdi','Al-Harbi','Al-Otaibi','Al-Qahtani','Al-Shehri','Al-Mutairi','Al-Zahrani','Al-Dossari','Al-Qurashi','Al-Juhani','Al-Maliki','Al-Anazi','Al-Amri','Al-Bishi'] },
  'South Korea': { first: ['Min-jun','Seo-jun','Do-yoon','Ha-joon','Joon-woo','Ji-ho','Jae-min','Seung-hyun','Tae-yang','Dong-hyun','Sung-min','Hyun-woo','Woo-jin','Ji-hoon','Jun-young'], last: ['Kim','Lee','Park','Choi','Jung','Kang','Jo','Yoon','Jang','Lim','Han','Oh','Shin','Seo','Kwon'] },
  China: { first: ['Wei','Hao','Jie','Yang','Lei','Chao','Tao','Bin','Feng','Qiang','Jun','Lin','Peng','Long','Kai'], last: ['Wang','Li','Zhang','Liu','Chen','Yang','Huang','Zhou','Wu','Xu','Sun','Hu','Zhu','Gao','Lin'] },
  Australia: { first: ['Jack','Oliver','William','Lachlan','Noah','Thomas','James','Henry','Ethan','Lucas','Mason','Jackson','Hunter','Liam','Logan'], last: ['Smith','Jones','Williams','Brown','Taylor','Wilson','Johnson','White','Martin','Thompson','Anderson','Thomas','Roberts','Lewis','Walker'] },
  Thailand: { first: ['Somchai','Anan','Kittichai','Apirak','Phongsak','Chalerm','Supachai','Narong','Surachet','Taweesak','Sanchai','Pornchai','Jirayu','Sarawut','Weerayot'], last: ['Saetang','Jaidee','Rungruang','Phromphol','Boonma','Chaiyaphon','Worachai','Srisai','Thongdee','Silamai','Kulap','Lertpanyakorn','Tangkanchai','Wichai','Phongphai'] },
  Iran: { first: ['Ali','Mohammad','Amir','Reza','Hossein','Mehdi','Hassan','Ahmad','Saeed','Morteza','Mostafa','Javad','Pouya','Arman','Arash'], last: ['Hosseini','Ahmadi','Mohammadi','Rezaei','Karimi','Taheri','Alizadeh','Moradi','Sadeghi','Rahimi','Kazemi','Ghasemi','Jafari','Hashemi','Bagheri'] },
  UAE: { first: ['Omar','Rashid','Saeed','Hamdan','Mohammed','Khalid','Sultan','Hamad','Ahmed','Abdulaziz','Fahad','Majid','Ali','Yousef','Zayed'], last: ['Al Nahyan','Al Maktoum','Al Marzouqi','Al Suwaidi','Al Ameri','Al Shamsi','Al Balooshi','Al Hammadi','Al Mansoori','Al Dhaheri','Al Falasi','Al Ketbi','Al Nuaimi','Al Qubaisi','Al Rashidi'] },
  Qatar: { first: ['Akram','Almoez','Hassan','Abdulkarim','Bassam','Karim','Tarek','Mohammed','Abdelrahman','Salem','Ismail','Yusuf','Musab','Sultan','Omar'], last: ['Al Thani','Al Haydos','Al Khalfan','Hassan','Boudiaf','Afif','Al Hajri','Al Sheeb','Al Moez','Al Rawi','Madibo','Khoukhi','Waad','Bassam','Homam'] },
  India: { first: ['Rohit','Sunil','Rahul','Amit','Vikram','Arjun','Ravi','Sanjay','Naveen','Harish','Gurpreet','Sandesh','Anirudh','Prithvi','Lalengmawia'], last: ['Sharma','Singh','Kumar','Patel','Yadav','Verma','Gupta','Reddy','Chhetri','Thapa','Jhingan','Lalrindika','Fernandez','Thapa','Colaco'] },
  Uzbekistan: { first: ['Abbos','Akmal','Bakhtiyor','Dilshod','Farrukh','Jasur','Kamil','Mukhammadjon','Odil','Rustam','Sardor','Shavkat','Ulugbek','Zafar','Azizbek'], last: ['Alimov','Abdullaev','Ergashev','Islomov','Karimov','Normatov','Oripov','Rakhmatullaev','Saidov','Tursunov','Usmanov','Yuldashev','Zakirov','Shukurov','Khalilov'] },
  Vietnam: { first: ['Minh','Huy','Duy','Khanh','Nam','Phong','Quang','Thanh','Tuan','Van','Hieu','Long','Kien','Tan','Phuc'], last: ['Nguyen','Tran','Le','Pham','Hoang','Vu','Dang','Bui','Do','Ngo','Duong','Ly','Chu','Dinh','Trinh'] },
  Indonesia: { first: ['Budi','Agus','Eko','Dwi','Hendra','Iwan','Joko','Rizki','Slamet','Tri','Yudi','Arif','Bagus','Dimas','Fajar'], last: ['Saputra','Wijaya','Pratama','Setiawan','Nugroho','Hidayat','Kurniawan','Hartono','Permana','Ananda','Susanto','Santoso','Wibowo','Gunawan','Hakim'] },
  Malaysia: { first: ['Ahmad','Muhammad','Azhar','Faizal','Hafiz','Ismail','Khairul','Mohd','Nazmi','Safawi','Syafiq','Zaquan','Amri','Baddrol','Norshahrul'], last: ['Abdullah','Ibrahim','Ismail','Othman','Yusof','Hassan','Hussein','Rashid','Mahmood','Ahmad','Sulaiman','Said','Kamaruddin','Effendi','Rahim'] }
};

const flagForCountry = {
  Spain: '🇪🇸', Italy: '🇮🇹', Germany: '🇩🇪', England: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  France: '🇫🇷', Portugal: '🇵🇹', Netherlands: '🇳🇱', Brazil: '🇧🇷', Argentina: '🇦🇷',
  'Saudi Arabia': '🇸🇦', 'South Korea': '🇰🇷', China: '🇨🇳', Australia: '🇦🇺',
  Thailand: '🇹🇭', Iran: '🇮🇷', UAE: '🇦🇪', Qatar: '🇶🇦', India: '🇮🇳',
  Uzbekistan: '🇺🇿', Vietnam: '🇻🇳', Indonesia: '🇮🇩', Malaysia: '🇲🇾', Japan: '🇯🇵'
};

const generateName = (country) => {
  const pool = NAME_POOLS[country] || NAME_POOLS.England;
  return `${pool.first[Math.floor(Math.random() * pool.first.length)]} ${pool.last[Math.floor(Math.random() * pool.last.length)]}`;
};

// Position distribution across 25-man roster
const ROSTER_POSITIONS = [
  'GK','GK','GK',
  'CB','CB','CB','LB','LB','RB','RB',
  'CDM','CDM','CM','CM','CM','CAM','LM','RM',
  'LW','LW','RW','RW','ST','ST','CF'
];

/**
 * Build a full 25-player team from team definition.
 * Stars placed first (starting XI), rest are generated based on country.
 * @param {Object} def team definition {name, country, flag, teamOvr, stars?, formation?}
 * @param {String} idPrefix
 */
export const buildTeamFromDefinition = (def, idPrefix) => {
  const teamId = `${idPrefix}-${def.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`;
  const stars = def.stars || [];
  const players = [];
  let number = 1;
  // Add stars first
  stars.forEach((s) => {
    players.push({
      id: `${teamId}-p-${number}`,
      number,
      name: s.name,
      position: s.position,
      overall: s.overall,
      age: s.age,
      nationality: def.country,
      flag: def.flag,
      potential: Math.min(99, s.overall + Math.floor(Math.random() * 3) + (s.age < 25 ? 4 : 0)),
      seasonStartOverall: s.overall,
      stats: EMPTY_STATS(),
      isRookie: s.age <= 19
    });
    number++;
  });
  // Fill remaining slots
  while (players.length < ROSTER_SIZE) {
    const pos = ROSTER_POSITIONS[players.length] || 'CM';
    const ageMin = pos === 'GK' ? 21 : 18;
    const ageMax = pos === 'GK' ? 37 : 34;
    const age = Math.floor(Math.random() * (ageMax - ageMin + 1)) + ageMin;
    // Filler rating range: teamOvr-8 to teamOvr-2
    const overall = Math.max(60, Math.min(94, def.teamOvr - 8 + Math.floor(Math.random() * 7)));
    const potential = Math.min(99, overall + Math.floor(Math.random() * 5) + (age < 23 ? 5 : 0));
    players.push({
      id: `${teamId}-p-${number}`,
      number,
      name: generateName(def.country),
      position: pos,
      overall, age,
      nationality: def.country,
      flag: def.flag,
      potential,
      seasonStartOverall: overall,
      stats: EMPTY_STATS(),
      isRookie: age <= 19
    });
    number++;
  }
  // Sort players so starters (higher ratings) get first numbers
  // But keep star players at their existing numbers (they're already top)
  // Adjust: re-sort bench part by overall
  const starters = players.slice(0, LINEUP_SIZE);
  const bench = players.slice(LINEUP_SIZE).sort((a, b) => b.overall - a.overall);
  const finalPlayers = [...starters, ...bench].map((p, i) => ({ ...p, number: i + 1 }));
  const base = {
    id: teamId,
    name: def.name,
    city: def.country,
    country: def.country,
    flag: def.flag,
    league: def.league,
    teamOvr: def.teamOvr,
    formation: def.formation || FORMATIONS[0].name,
    players: finalPlayers,
    stats: { played: 0, won: 0, drawn: 0, lost: 0, goalsFor: 0, goalsAgainst: 0, points: 0 }
  };
  const { lineup, bench: benchNums } = buildLineupForFormation(base);
  return { ...base, lineup, bench: benchNums };
};

// Create CWC team set (32 teams, one-time; then persisted in gameState)
export const buildCWCTeams = () => CWC_TEAMS_DATA.map(def => buildTeamFromDefinition(def, 'cwc'));
// Create Champions League team set (28 teams)
export const buildAsianCupTeams = () => CHAMPIONS_LEAGUE_TEAMS_DATA.map(def => buildTeamFromDefinition(def, 'asian'));
// Legacy alias kept for backwards-compatibility with any in-flight imports.
export const buildChampionsLeagueTeams = buildAsianCupTeams;

// ============================================================
// Secondary Asian pools (used by Player Career for broader team variety)
// All replaced with Asian clubs so no European teams appear in JWFL.
// ============================================================
export const EUROPA_LEAGUE_TEAMS_DATA = [
  { name: 'Kashima Antlers', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 80 },
  { name: 'Urawa Red Diamonds', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 79 },
  { name: 'Gamba Osaka', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 78 },
  { name: 'Daegu FC', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 80 },
  { name: 'Suwon Bluewings', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 79 },
  { name: 'Shanghai Shenhua', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 78 },
  { name: 'Guangzhou FC', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 77 },
  { name: 'Al Shabab', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 81 },
  { name: 'Al Fateh SC', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 79 },
  { name: 'Sepahan SC', country: 'Iran', flag: '🇮🇷', league: 'PGL', teamOvr: 79 },
  { name: 'Tractor Tabriz', country: 'Iran', flag: '🇮🇷', league: 'PGL', teamOvr: 77 },
  { name: 'Al Wahda', country: 'UAE', flag: '🇦🇪', league: 'ADNOC PL', teamOvr: 78 },
  { name: 'Al Rayyan', country: 'Qatar', flag: '🇶🇦', league: 'QSL', teamOvr: 78 },
  { name: 'Istiklol Dushanbe', country: 'Uzbekistan', flag: '🇺🇿', league: 'UPL', teamOvr: 76 }
];

export const CONFERENCE_LEAGUE_TEAMS_DATA = [
  { name: 'Yokohama FC', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 76 },
  { name: 'Shimizu S-Pulse', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 75 },
  { name: 'Albirex Niigata', country: 'Japan', flag: '🇯🇵', league: 'J.League', teamOvr: 74 },
  { name: 'Gangwon FC', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 76 },
  { name: 'Jeju United', country: 'South Korea', flag: '🇰🇷', league: 'K League 1', teamOvr: 75 },
  { name: 'Chengdu Rongcheng', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 75 },
  { name: 'Dalian Pro', country: 'China', flag: '🇨🇳', league: 'CSL', teamOvr: 73 },
  { name: 'Al Taawoun', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 77 },
  { name: 'Al Fayha', country: 'Saudi Arabia', flag: '🇸🇦', league: 'SPL', teamOvr: 75 },
  { name: 'Chonburi FC', country: 'Thailand', flag: '🇹🇭', league: 'Thai L1', teamOvr: 74 },
  { name: 'Port FC', country: 'Thailand', flag: '🇹🇭', league: 'Thai L1', teamOvr: 73 },
  { name: 'Bengaluru FC', country: 'India', flag: '🇮🇳', league: 'ISL', teamOvr: 74 },
  { name: 'Hanoi FC', country: 'Vietnam', flag: '🇻🇳', league: 'V-League', teamOvr: 74 },
  { name: 'Bali United', country: 'Indonesia', flag: '🇮🇩', league: 'Liga 1', teamOvr: 73 }
];

export const buildEuropaLeagueTeams = () => EUROPA_LEAGUE_TEAMS_DATA.map(def => buildTeamFromDefinition(def, 'uel'));
export const buildConferenceLeagueTeams = () => CONFERENCE_LEAGUE_TEAMS_DATA.map(def => buildTeamFromDefinition(def, 'uecl'));
